import type { IconProps } from './../../models/icon';

export function CoffeeIcon({
  width = 24,
  height = 24,
  secondaryColor = 'var(--color-200)',
  className = '',
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      width={width}
      height={height}
      className={className}
    >
      <path
        fill={secondaryColor}
        d="M5.143 9.42856H13.7144C14.1691 9.42856 14.6051 9.60918 14.9266 9.93066C15.2481 10.2522 15.4287 10.6882 15.4287 11.1428V19.7143C15.4287 20.6235 15.0675 21.4956 14.4245 22.1386C13.7815 22.7816 12.9094 23.1428 12.0001 23.1428H6.85728C5.94797 23.1428 5.0759 22.7816 4.43292 22.1386C3.78993 21.4956 3.42871 20.6235 3.42871 19.7143V11.1428C3.42871 10.6882 3.60933 10.2522 3.93081 9.93066C4.25231 9.60918 4.68833 9.42856 5.143 9.42856Z"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.7"
        d="M5.143 9.42856H13.7144C14.1691 9.42856 14.6051 9.60918 14.9266 9.93066C15.2481 10.2522 15.4287 10.6882 15.4287 11.1428V19.7143C15.4287 20.6235 15.0675 21.4956 14.4245 22.1386C13.7815 22.7816 12.9094 23.1428 12.0001 23.1428H6.85728C5.94797 23.1428 5.0759 22.7816 4.43292 22.1386C3.78993 21.4956 3.42871 20.6235 3.42871 19.7143V11.1428C3.42871 10.6882 3.60933 10.2522 3.93081 9.93066C4.25231 9.60918 4.68833 9.42856 5.143 9.42856Z"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.7"
        d="M15.4287 11.1428H16.2859C17.4224 11.1428 18.5125 11.5944 19.3164 12.3981C20.12 13.2018 20.5716 14.2919 20.5716 15.4286C20.5716 16.5652 20.12 17.6552 19.3164 18.4591C18.5125 19.2627 17.4224 19.7143 16.2859 19.7143H15.4287"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.7"
        d="M6.85693 0.857117V4.28569"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.7"
        d="M12 0.857117V4.28569"
      />
    </svg>
  );
}
